import { type ReactNode } from 'react';

import { Tooltip } from '@air/primitive-tooltip';

import {
  RecentlyDeletedTableCell,
  type RecentlyDeletedTableCellProps,
} from '~/components/RecentlyDeleted/components/RecentlyDeletedTableCell';
import { getTableColumnWidth } from '~/components/RecentlyDeleted/utils/getTableColumnWidth';
import { DEFAULT_THUMBNAIL_DIMENSIONS } from '~/components/TableView/NameCell/dimensions';
export type RecentlyDeletedTableCellTitleProps = Pick<RecentlyDeletedTableCellProps, 'style'> & {
  thumbnail: ReactNode;
  meta?: ReactNode;
  title: ReactNode;
};

export const RecentlyDeletedTableCellTitle = ({
  meta,
  thumbnail,
  title,
  style,
}: RecentlyDeletedTableCellTitleProps) => (
  <RecentlyDeletedTableCell className="gap-3" style={style} width={getTableColumnWidth('title')}>
    <div className="relative shrink-0 rounded-4 bg-grey-5" style={{ ...DEFAULT_THUMBNAIL_DIMENSIONS }}>
      {thumbnail}
    </div>

    <div>
      <Tooltip label={title} side="top" sideOffset={4} align="start">
        <div className="truncate font-medium text-14 text-grey-12">{title}</div>
      </Tooltip>
      {!!meta && <div className="text-14 text-grey-11">{meta}</div>}
    </div>
  </RecentlyDeletedTableCell>
);
